import { frLocaleText } from "./grid-fr";
import { enLocaleText } from "./grid-en";
import store from "@/stores/store";

/**
 * Libellés ag-grid (localeText) dans la langue courante de l'utilisateur.
 * Le français reste la langue par défaut.
 */
export function getLocaleText() {
  const locale = (store.getters["user/getLocale"] || "fr").toString().split("-")[0];
  return locale === "en" ? enLocaleText : frLocaleText;
}
